import api from "./api"


// =========================================================
// Helpers
// =========================================================

const cleanParams = (params = {}) => {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        value !== "all"
    )
  )
}


// =========================================================
// Données formulaire
// =========================================================

export const getPurchaseRequestFormData = async (
  params = {}
) => {
  const response = await api.get(
    "/purchase-requests/form-data",
    {
      params: cleanParams(params),
    }
  )

  return response.data
}


// =========================================================
// Produits compatibles avec un entrepôt
// =========================================================

export const getPurchaseRequestProductsForWarehouse =
  async (warehouseId) => {
    if (!warehouseId) {
      return getPurchaseRequestFormData()
    }

    return getPurchaseRequestFormData({
      warehouse_id: warehouseId,
    })
  }


// =========================================================
// Liste des demandes d'achat
// =========================================================

export const getPurchaseRequests = async (
  params = {}
) => {
  const response = await api.get(
    "/purchase-requests",
    {
      params: cleanParams(params),
    }
  )

  return response.data
}


// =========================================================
// Détail d'une demande
// =========================================================

export const getPurchaseRequestById = async (
  requestId
) => {
  const response = await api.get(
    `/purchase-requests/${requestId}`
  )

  return response.data
}


// =========================================================
// Création
// =========================================================

export const createPurchaseRequest = async (
  payload
) => {
  const response = await api.post(
    "/purchase-requests",
    payload
  )

  return response.data
}


// =========================================================
// Modification
// =========================================================

export const updatePurchaseRequest = async (
  requestId,
  payload
) => {
  const response = await api.put(
    `/purchase-requests/${requestId}`,
    payload
  )

  return response.data
}


// =========================================================
// Soumission
// DRAFT -> SUBMITTED
// =========================================================

export const submitPurchaseRequest = async (
  requestId
) => {
  const response = await api.post(
    `/purchase-requests/${requestId}/submit`,
    {}
  )

  return response.data
}


// =========================================================
// Approbation
// SUBMITTED -> APPROVED
// =========================================================

export const approvePurchaseRequest = async (
  requestId,
  payload = {}
) => {
  const response = await api.post(
    `/purchase-requests/${requestId}/approve`,
    payload
  )

  return response.data
}


// =========================================================
// Rejet
// SUBMITTED -> REJECTED
// =========================================================

export const rejectPurchaseRequest = async (
  requestId,
  payload = {}
) => {
  const response = await api.post(
    `/purchase-requests/${requestId}/reject`,
    payload
  )

  return response.data
}


// =========================================================
// Annulation
// =========================================================

export const cancelPurchaseRequest = async (
  requestId
) => {
  const response = await api.post(
    `/purchase-requests/${requestId}/cancel`,
    {}
  )

  return response.data
}